export function formatEmpAttHours(totalHours) {
	// Convert the total hours to a string
	let formattedHours = totalHours.toString();

	// Split the string into hours and minutes
	const parts = formattedHours.split('.');

	// If the number has a decimal point
	if (parts.length > 1) {
		// Convert minutes to a 2-digit format if needed
		if (parts[1].length === 1) {
			parts[1] = parts[1] + '0'; // Add a trailing '0'
		}
		formattedHours = `${parts[0]}:${parts[1]}`;
	} else {
		// If there's no decimal point, append ':00'
		formattedHours = `${parts[0]}:00`;
	}

	return formattedHours;
}

export function addHHMMTime(totalTime, newTime) {
	if (!newTime) return totalTime || '00:00'; // Return existing time if new time is undefined

	const [hours1, minutes1] = (totalTime || '00:00').split(':').map(Number);
	const [hours2, minutes2] = newTime.split(':').map(Number);

	let totalMinutes = hours1 * 60 + minutes1 + (hours2 * 60 + minutes2);

	const hours = Math.floor(totalMinutes / 60); // Get the hours
	const minutes = totalMinutes % 60; // Get the remaining minutes

	return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`; // Return the formatted time
}
